import { WorkScheduleUnit } from '../../../types/availability';
import collect from 'collect.js';
import moment from 'moment-timezone';
import { WorkScheduleHelpers } from '../schedule/WorkScheduleHelpers';
import DateHelpers, { Hour, Minute } from '../DateHelpers';

export class OpenStreetMapHelpers {
  public static createScheduleString(schedule: WorkScheduleUnit[]): string {
    return collect(WorkScheduleHelpers.groupByDay(schedule))
      .map((item) => `${moment().day(item.day).format('dd')} ${item.entries.replaceAll(' ', '')}`)
      .implode('; ');
  }

  public static toScheduleUnit(rule: string): WorkScheduleUnit {
    const fromDay = DateHelpers.dayNumberFromString(rule.slice(0, 2));
    const fromHour = +rule.slice(3, 5) as Hour;
    const fromMinute = +rule.slice(6, 8) as Minute;

    const toHour = +rule.slice(9, 11) as Hour;
    const toMinute = +rule.slice(12, 15) as Minute;

    const isOverMidnight = toHour < fromHour || (toHour === fromHour && toMinute < fromMinute);

    return {
      open: {
        day: fromDay,
        hour: fromHour,
        minute: fromMinute,
      },
      close: {
        day: isOverMidnight ? DateHelpers.getNextDayNumber(fromDay) : fromDay,
        hour: toHour,
        minute: toMinute,
      },
    };
  }

  public static isOpenRule(rule: string): boolean {
    return !rule.endsWith('off');
  }
}
